<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.addTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-translation-add-form" tag="form" @keydown.enter.prevent>
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <validation-provider
              rules="required"
              name="language"
              v-slot="{ errors }">
              <d-form-select
                v-model="language"
                :options="languageOptions"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('customer.termsOfSale') }}:
            </label>

            <validation-provider
              rules="required"
              name="terms_of_sale"
              v-slot="{ errors }">
              <d-textarea
                :state="errors.length ? 'invalid' : null"
                v-model="terms_of_sale"
                :rows="5" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        <i class="material-icons">add</i>
        {{ $t('settings.transaltion.addTranslation') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-translation-new-popup',
  props: {
    customerID: {
      default: 0,
      type: Number
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    languageOptions () {
      return [{
        value: null,
        text: this.$t('settings.language.chooseLanguage')
      }].concat(this.languages.filter(language => language.id > 1).map(language => ({
        value: language.id,
        text: language.name
      })));
    }
  },
  data () {
    return {
      language: null,
      terms_of_sale: ''
    };
  },
  methods: {
    handleClose (newTranslationID = false) {
      this.$bus.$emit('customer-translation-new-popup-close', newTranslationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-translation-add-form'], this.saveTranslation);
    },
    saveTranslation () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/customer-panel/partner-customers/translations/store',
        formData: {
          customer_id: this.customerID,
          language_id: this.language,
          terms_of_sale: this.terms_of_sale
        },
        successTitle: this.$t('settings.transaltion.addTranslationSuccessTitle'),
        successText: this.$t('settings.transaltion.addTranslationSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.addTranslationErrorText'),
        successAction: res => {
          this.$bus.$emit('customer-reload-translations');
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
